module.exports = __webpack_public_path__ + "img/1.38f7b201.png";